// @flow
import React, { Component } from 'react'
import ExpandingDropdown from '../AdvertisementsTable/ExpandingDropdown'
import BudgetSelect from '../AudienceEdit/BudgetSelect'
import { translateFunc, translations } from '../../shared/localize'
import styled, { createGlobalStyle, type StyledComponent } from 'styled-components'
import postJson from '../../services/postJson'
import _ from 'lodash'
import { priceBudgetUpdateUrl } from '../CampaignsTable'

const GlobalStyle = createGlobalStyle`
.budget-popup__budget-select-error {
  word-wrap: break-word;
  max-width: 170px;
}

.budget-popup__trigger {
  display: inline-block;
  border-bottom: 1px dashed rgba(97, 184, 211, .5);
  text-decoration: none;
}

.budget-popup__btns {
  margin-top: 15px;
  text-align: left;
}
`
const Link: StyledComponent<Object, any, any> = styled.a`
  border-bottom: 1px dashed rgba(97, 184, 211, 0.5);
  text-decoration: none;
`
const Wrapper: StyledComponent<Object, any, any> = styled.div`
  padding: 5px;
`

type Props = {|
  budget: string,
  budgetCycle: string,
  minMonthBudget: number,
  minDailyBudget: number,
  maxBudget: number,
  audienceId: number,
  onAudienceStateChange: Function
|}

type State = {|
  budget: string,
  budgetCycle: string,
  isOpen: boolean
|}

const t = translateFunc(translations.campaigns_table.budget_popup)

export default class BudgetPopup extends Component<Props, State> {
  budgetSelect: any

  constructor(props: Props) {
    super(props)

    this.state = {
      budget: props.budget.replace(' ', ''),
      budgetCycle: props.budgetCycle,
      isOpen: false
    }
  }

  dropdownChanged(isOpen: boolean) {
    if (!isOpen) {
      this.setState({
        budget: this.props.budget.replace(' ', ''),
        budgetCycle: this.props.budgetCycle
      })
    }
    this.setState({ isOpen })
  }

  componentDidUpdate(prevProps: Props) {
    if (!_.isEqual(prevProps.budget, this.props.budget)) {
      this.setState({ budget: this.props.budget })
    }
  }

  submit() {
    const { budget, budgetCycle } = this.state
    const { audienceId, onAudienceStateChange } = this.props
    postJson(priceBudgetUpdateUrl, {
      data: {
        audience_ids: [audienceId],
        param_to_change: 'budget',
        change_type: 'set',
        value_change_type: 'absolute',
        value: budget,
        budget_cycle: budgetCycle
      }
    })
      .done((response) => {
        onAudienceStateChange(response.data.audiences, audienceId)
        this.setState({ isOpen: false })
        window.alert(response.data.result_text.join('\n'))
      })
      .fail((response: any) => {
        this.budgetSelect.setErrors(response.responseJSON.message.value)
      })
  }

  renderPopupContent() {
    const { budget, budgetCycle } = this.state

    return (
      <Wrapper>
        <GlobalStyle />
        <BudgetSelect
          ref={(el) => {
            this.budgetSelect = el
          }}
          cycleOptions={[
            [t('budget_cycle_month'), 'month'],
            [t('budget_cycle_day'), 'day']
          ]}
          minMonthBudget={this.props.minMonthBudget}
          minDailyBudget={this.props.minDailyBudget}
          maxBudget={this.props.maxBudget}
          budgetCycle={budgetCycle}
          budget={budget}
          hideHints
          onChange={(object) => this.setState(object)}
          errors={[]}
          autoFocus
        />
        <div className="budget-popup__btns">
          <button className="btn btn-success" onClick={() => this.submit()}>
            {t('save_btn')}
          </button>{' '}
          <button className="btn btn-default" onClick={() => this.dropdownChanged(false)}>
            {t('cancel_btn')}
          </button>
        </div>
      </Wrapper>
    )
  }

  renderTrigger() {
    const { budget, budgetCycle } = this.props

    return (
      <Link
        href="#"
        className="budget-popup__trigger offable t-BudgetPopupTrigger"
        onClick={(event) => {
          event.preventDefault()
        }}
      >
        {budget} {t(`budget_cycle_${budgetCycle}_cell`)}
      </Link>
    )
  }

  render() {
    return (
      <ExpandingDropdown
        isOpen={this.state.isOpen}
        triggerText={this.renderTrigger()}
        onChange={(isOpen) => this.dropdownChanged(isOpen)}
        inlineBlock
      >
        {this.renderPopupContent()}
      </ExpandingDropdown>
    )
  }
}
